import React from "react";

function StackedTitle({ groups, className = "" }) {
  const rootClassName = ["stacked-section-title", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName}>
      <h2>
        {groups.map((group, groupIndex) => (
          <span className="stacked-section-title__group" key={groupIndex}>
            {group.map(line => (
              <span
                className={`stacked-section-title__line${
                  line.tone === "accent" ? " stacked-section-title__line--accent" : ""
                }`}
                key={line.text}
              >
                {line.text}
              </span>
            ))}
          </span>
        ))}
      </h2>
    </div>
  );
}

export default StackedTitle;
